import { Grid, GridColumn, Heading, Image, Separator, Text } from 'telia-front-react';
import * as React from 'react';

interface PageErrorBoundaryProps {
  children: React.ReactNode;
}

class PageErrorBoundary extends React.Component<PageErrorBoundaryProps> {
  public state = {
    hasError: false
  };

  public componentDidCatch() {
    this.setState({ hasError: true });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div>
          <Separator color={'invisible'} />
          <Grid>
            <GridColumn className="grid__col--sm-6 grid__col--md-6">
              <Text>
                <Image src="//static.telia.ee/diil/diil-logo.svg" width={70} role={'presentation'} />
                <Heading element={'h1'}>KODULEHEL ON HOOLDUSTÖÖD!!</Heading>
                <Heading element={'h4'}>Seoses hooldustöödega veebileht ei tööta.</Heading>
                <Heading element={'h4'}> Ootame Sind aga juba õige pea tagasi!</Heading>
                <Separator color={'invisible'} />
                <Heading element={'h1'}>ПРОВОДИТСЯ СЕРВИСНОЕ ОБСЛУЖИВАНИЕ!</Heading>
                <Heading element={'h4'}>Вы застали нас врасплох! Как раз сейчас мы обновляем сайт.</Heading>
                <Heading element={'h4'}>Домашняя страница не работает в связи с работами по обслуживанию. Ждём Вас обратно в скором времени!</Heading>
              </Text>
            </GridColumn>
            <GridColumn className="grid__col--sm-6 grid__col--md-6">
              <Separator color={'invisible'} />
              <Image
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                className="img-responsive center-block lazyautosizes lazyloaded"
                width={462}
                // tslint:disable-next-line:max-line-length
                srcset="//res.cloudinary.com/telia/image/upload/c_scale,w_462,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 462w, //res.cloudinary.com/telia/image/upload/c_scale,w_925,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 925w"
                role={'presentation'}
              />
            </GridColumn>
          </Grid>
        </div>
      );
    }
    return this.props.children;
  }
}

export default PageErrorBoundary;
